import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Autocomplete, Box, SxProps, TextField, Tooltip } from "@mui/material";
import moment from "moment-timezone";

const zones = new Set<string>();
const countries = moment.tz.countries();

for (const country of countries) {
  moment.tz.zonesForCountry(country).reduce((set, zone) => set.add(zone), zones);
}

const TIMEZONE_NAMES = [...zones].sort();

export interface MenuTimezoneSelectProps {
  value: string;
  onChange: (value: string) => void;
  className?: string;
  sx?: SxProps;
  error?: boolean;
  helperText?: string;
  disabled?: boolean;
  showTooltip?: boolean;
}

const MenuTimezoneSelect = ({ value, onChange, className, sx, error, helperText, disabled, showTooltip }: MenuTimezoneSelectProps) => (
  <Box sx={{ display: "flex", alignItems: "flex-start", gap: 1 }}>
    <Autocomplete
      options={TIMEZONE_NAMES}
      disabled={disabled}
      value={value}
      onChange={(_, val) => {
        if (val) {
          onChange(val);
        }
      }}
      disableClearable
      renderInput={params => (
        <TextField
          {...{
            ...params,
            inputProps: {
              ...params.inputProps,
              "aria-label": "Timezone",
            },
          }}
          sx={{
            minWidth: "250px",
            ...sx,
          }}
          className={className}
          label={"Timezone"}
          error={error}
          helperText={helperText}
        />
      )}
    />
    {showTooltip && (
      <Tooltip title="For organizations that allow orders, set this timezone to reflect the pickup order's local timezone.">
        <InfoOutlinedIcon
          sx={{ alignSelf: "center", color: "action.active", mt: 2, cursor: "pointer", justifySelf: "align-end" }}
          fontSize="small"
        />
      </Tooltip>
    )}
  </Box>
);

export default MenuTimezoneSelect;
